var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.893 12.522l.042.008c.04.016.065.054.065.095v6.75c0 .621-.522 1.125-1.167 1.125H10.167C9.522 20.5 9 19.996 9 19.375v-6.75c0-.041.025-.078.064-.095a.108.108 0 01.117.022l5.683 5.482a1.646 1.646 0 002.268 0l5.686-5.482a.11.11 0 01.117-.021zm-1.06-1.022c.16 0 .339.017.403.202a.274.274 0 01-.07.287l-5.65 5.449a.75.75 0 01-1.032 0l-5.65-5.449a.274.274 0 01-.07-.287c.063-.185.242-.202.403-.202z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgEmail;